import { Field } from 'formik'
import { useState } from 'react'

import { IconButton, InputAdornment, TextFieldVariants } from '@mui/material'
import { Visibility, VisibilityOff } from '@mui/icons-material'

import { TextInput } from '../Text'

export interface PasswordInputProps {
  name: string
  placeholder: string
  autoComplete?: string
  label?: string
  variant?: TextFieldVariants
  size?: 'small' | 'normal'
}

export function PasswordInput({ name, placeholder, autoComplete, label, variant, size = 'small' }: PasswordInputProps) {
  const [showPassword, setShowPassword] = useState(false)

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev)
  }

  return (
    <Field
      component={TextInput}
      placeholder={placeholder}
      name={name}
      id={name}
      label={label}
      type={showPassword ? 'text' : 'password'}
      autoComplete={autoComplete}
      size={size}
      variant={variant}
      InputProps={{
        disableUnderline: true,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton aria-label="toggle password visibility" onClick={handleTogglePasswordVisibility} edge="end">
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      sx={{ flex: 1 }}
    />
  )
}
